import React, {useEffect} from "react";
import { motion } from "framer-motion";
import classes from "./LandingPage.module.css";
// import IdeaMap from "../IdeaMap/IdeaMap"; // screenshot/preview or embed if you want
import { useNavigate } from "react-router-dom"; // 👈 if you’re using react-router
import ExampleGraph from "../ExampleGraph/ExampleGraph";
import myembeddedsystems from "../../assets/myembeddedsystems.png";

const LandingPage = () => {
    const navigate = useNavigate();
    useEffect(() => {
  window.history.scrollRestoration = "manual";
}, []);


  return (
    <div className={classes.outer_div}>
      {/* Section 1: Hero */}
      <section className={classes.section}>
        <motion.div
          className={classes.text}
          initial={{ x: -100, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8 }}
        >

          {/* <img src={dandy} style={{ height: "300px" }} alt="Just a simple house and sun"/> */}
          <h1>Visualize Your Ideas</h1>
          {/* <p>
            Turn your thoughts into an interactive mindmap. Explore questions,
            answers, and insights like never before.
          </p> */}
          
          <p>
            Turn your thoughts into an interactive mindmap. Explore questions,
            answers, and insights like never before.
          </p>
          <motion.button
            className={classes.ctaButton}
            whileHover={{ backgroundColor: "#2196F3", color: "#fff", x: 5 }}
            whileTap={{ scale: 0.95 }}
            // onClick={() => navigate("/ideamap")}
            onClick={() => navigate("/dailyweb")}
          >Enter Flow State</motion.button>
        </motion.div>

        <motion.div
          className={classes.image}
          initial={{ x: 100, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8 }}
        >
          {/* You can replace this with a screenshot of IdeaMap or embed it */}
          <div className={classes.mockup}>
            <ExampleGraph/>
          </div>
        </motion.div>
      </section>

      {/* Section 4: Embedded Systems Partner Section
<section className={classes.embedded_section}>
  <motion.div
    className={classes.embedded_content}
    initial={{ opacity: 0, y: 60 }}
    whileInView={{ opacity: 1, y: 0 }}
    transition={{ duration: 0.9, ease: "easeOut" }}
    viewport={{ once: true }} 
  >
    <div className={classes.text_block}>
      <h2>Powering the Real World with <span style={{color: "green"}}>MyEmbeddedSystems</span></h2>
      <p>
        The same minds behind dothink.ai build real hardware solutions at
        <strong> myembeddedsystems.com</strong> — bringing ideas to life through
        custom firmware, circuit design, and connected devices. From STM32 to
        Raspberry Pi, we turn imagination into innovation.
      </p>
      <a
        href="https://myembeddedsystems.com"
        target="_blank"
        rel="noopener noreferrer"
        className={classes.visit_button}
      >
        Visit MyEmbeddedSystems →
      </a>
    </div>

    <motion.img
      src={myembeddedsystems} // ← add a moving schematic / PCB render here
      alt="Embedded Systems"
      className={classes.embedded_image}
      animate={{ y: [0, -10, 0] }}
      transition={{ repeat: Infinity, duration: 3, ease: "easeInOut" }}
    />
  </motion.div>
</section> */}

    </div>
  );
};

export default LandingPage;
